import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

import { useTheme} from '@mui/material';

import apiClient from '../../../../services/api';
import store from "../../../../store/index";
import { toggleMessageOpen } from "../../../../store/actions/Message";
import { setStoresData } from '../../../../store/actions/Store';
import { LoadingScreen } from "../../../partials/LoadingScreen";

import StyledProjectList from "../../../partials/project/list/StyledProjectList";
import { setProjectSort } from "../../../../store/actions/FilterView";
import { VersionsDialog } from "../VersionsDialog";
import { createConfirmAction } from "../../../../store/actions/ConfirmDialog";

function StoreListContainer()
{
    const navigate = useNavigate();
    const theme = useTheme();
    const {t} = useTranslation();

    const [loading, setLoading] = useState(false);
    const [height, setHeight] = useState(400);
    const [sortArray, setSortArray] = useState(null);
    const [versionsDialogOpen, setVersionsDialogOpen] = useState(false);
    const [selectedFloorPlan, setSelectedFloorPlan] = useState(false);
    
    const isExpanded = useSelector((state) => state.filterView.projectListFilterOptionsExpanded);
    const floorPlanSort = useSelector((state) => state.filterView.projectSort);
    const floorPlanListFilters = useSelector((state) => state.filterView.floorPlanListFilters);
    const floorPlans = useSelector((state) => state.store.stores);

    useEffect(() => {
        setLoading(true);

        apiClient.post('/api/modules/check', {name: 'easyFloor'}).then(response => {
            if(!response.data.success) {
                store.dispatch(toggleMessageOpen(t("You don't have permission to enter this page"), "error"))

                navigate('/app/home');
            } else {
                setLoading(false)
            }
        })
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!floorPlanListFilters || !floorPlanSort) {
            return;
        }

        apiClient.post('/api/easy-floor/get-floor-plans', {filters: floorPlanListFilters, sort: JSON.parse(floorPlanSort)}).then(response => {
            if(response.data.success) {
                store.dispatch(setStoresData(response.data.floor_plans));
            }
        }).catch(error => {
            store.dispatch(toggleMessageOpen(error.response.data, "error"));
        });
    }, [floorPlanListFilters, floorPlanSort]);

    const handleDeleteClicked = (event, id) => {
        event.stopPropagation();

        store.dispatch(createConfirmAction(handleDelete, t('Are you sure?'), id));
    }

    const handleDelete = (id) => {
        apiClient.post('/api/easy-floor/delete', {id: id, filters: floorPlanListFilters, sort: JSON.parse(floorPlanSort)}).then( response => {
            if(response.data.success) {
                store.dispatch(toggleMessageOpen(t('Store deleted successfully'), 'success'));
                store.dispatch(setStoresData(response.data.floor_plans));
            } else {
                store.dispatch(toggleMessageOpen(response.data.message, 'error'))
            }

        }).catch( error => store.dispatch(toggleMessageOpen(error.response.data, "error")) )  
    }

    const handleClick = (selectedFloorPlan) => {
        navigate('/app/easy-floor/map/'+selectedFloorPlan)
    }

    const handleVersionDialogClose = () => {
        setVersionsDialogOpen(false);
        setSelectedFloorPlan(null);
    }

    const sort = (attribute) => {
        const array = JSON.parse(floorPlanSort);

        if(attribute === 'name') {
            array['date'] = null;

            if(!array['name']) {
                array['name'] = 'ASC';
            } else {
                array['name'] = array['name'] === 'ASC' ? 'DESC' : 'ASC';
            }
        } else {
            array['name'] = null;

            if(!array['date']) {
                array['date'] = 'ASC';
            } else {
                array['date'] = array['date'] === 'ASC' ? 'DESC' : 'ASC';
            }
        }

        store.dispatch(setProjectSort(JSON.stringify(array)));
        setSortArray(array);
    }

    return (
        !loading 
            ? [
                <StyledProjectList
                    height={height}
                    setHeight={setHeight}
                    handleDeleteClicked={handleDeleteClicked}
                    handleClick={handleClick}
                    isExpanded={isExpanded}
                    sort={sort}
                    sortArray={sortArray}
                    projects={floorPlans}
                    title={t('Floor Plans')}
                    type='floorPlan'
                    setVersionsDialogOpen={setVersionsDialogOpen}
                    setSelectedFloorPlan={setSelectedFloorPlan}
                />,
                <VersionsDialog
                    open={versionsDialogOpen}
                    handleClose={handleVersionDialogClose}
                    item={selectedFloorPlan}
                />
            ]
            : <LoadingScreen />
    );
}

export default StoreListContainer;